import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "menu-items" }
const _hoisted_3 = ["id", "onClick"]
const _hoisted_4 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleMenuItems, (menuItem) => {
        return (_openBlock(), _createElementBlock("div", {
          id: menuItem.id,
          key: menuItem.id,
          onClick: menuItem.action,
          class: _normalizeClass(['menu-item', { 'active': _ctx.isCurrentRoute(menuItem.routeName) } ])
        }, _toDisplayString(menuItem.label), 11, _hoisted_3))
      }), 128))
    ]),
    _createElementVNode("a", {
      id: "admin-site",
      class: "link-item",
      href: _ctx.wwsUrl,
      target: "_blank",
      rel: "noopener noreferrer"
    }, [...(_cache[0] || (_cache[0] = [
      _createElementVNode("span", null, "Admin", -1),
      _createElementVNode("span", { class: "material-symbols-outlined" }, "open_in_new", -1)
    ]))], 8, _hoisted_4)
  ]))
}